<main class="container-fluid">
    <div class="row">
        <div class="col-12">
            <h1>Editar Agview Connect</h1>
        </div>
    </div>
    <form [formGroup]="tabletForm">
        <div class="row">
            <div class="col-6">
                <label id="label-input">
                    <span>Cliente:</span>
                </label>
                <select type="number" class="input form-control form-control-sm" formControlName="fk_cliente">
                    <option [value]="cliente.sr_id" *ngFor="let cliente of clientes">
                        {{cliente.vc_nome}}
                    </option>
                </select>
                <ng-container *ngIf="tabletForm.controls.fk_cliente.touched">
                    <p class="msg-erro" *ngIf="tabletForm.controls.fk_cliente.errors">Campo obrigatório *</p>
                </ng-container>
            </div>
            <div class="col-6">
                <label id="label-input">
                    <span>Produto:</span>
                </label>
                <select type="number" formControlName="fk_produto" class="input  form-control form-control-sm">
                    <option [value]="produto.sr_id" *ngFor="let produto of produtos">{{produto.vc_nome}}
                    </option>
                </select>
                <ng-container *ngIf="tabletForm.controls.fk_produto.touched">
                    <p class="msg-erro" *ngIf="tabletForm.controls.fk_produto.errors">Campo obrigatório *</p>
                </ng-container>
            </div>
        </div>

        <div id="buttons">
            <button class="btn-sucesso" type="submit" (click)="editar()" [disabled]="tabletForm.invalid">Atualizar</button>
            <button (click)="cancelar()" class="btn-cancelar" type="button">Cancelar</button>
        </div>
    </form>
</main>